import { defineComponent as _defineComponent } from 'vue'
import {
  AbTitle,
  AbSection,
  AbContainer,
  AbLink,
  AbIcon,
  AbSectionLayout,
  AbDescription,
  AbTag,
} from '../../../ui';
import { Spacing } from '../../../../helpers/shared-props';
import { type TextAlign } from '../../../../types';
import { computed, ref } from 'vue-demi';
import BlogSectionSimpleSlider from './BlogSectionSimpleSlider.vue';
import BlogSectionSimpleGrid from './BlogSectionSimpleGrid.vue';

interface Props {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  textAlign?: TextAlign | null;
  moreLinkAlign?: TextAlign | null;
  link?: {
    src?: string | null;
    text: string;
  } | null;
  items: {
    image?: {
      src?: string | null;
      alt?: string | null;
    } | null;
    title: string;
    link?: string | null;
    tags?: string[] | null;
    contentAlign?: TextAlign | null;
  }[];
  gridView?: boolean | null;
  spacing?: Spacing | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BlogSectionSimple',
  props: {
    id: null,
    title: null,
    description: null,
    textAlign: null,
    moreLinkAlign: null,
    link: null,
    items: null,
    gridView: { type: [Boolean, null] },
    spacing: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  textAlign?: TextAlign | null;
  moreLinkAlign?: TextAlign | null;
  link?: {
    src?: string | null;
    text: string;
  } | null;
  items: {
    image?: {
      src?: string | null;
      alt?: string | null;
    } | null;
    title: string;
    link?: string | null;
    tags?: string[] | null;
    contentAlign?: TextAlign | null;
  }[];
  gridView?: boolean | null;
  spacing?: Spacing | null;
};

const ALL_TAGS = 'All tags';
const DEFAULT_TEXT_ALIGN = 'center';



const activeTag = ref(ALL_TAGS);
const tags = computed(() => {
  const tags = [
    ...new Set(
      props.items
        ?.map((item) => item.tags ?? [])
        .flat()
        .filter(Boolean),
    ),
  ];

  if (tags.length) tags.unshift(ALL_TAGS);
  return tags;
});
const selectTag = (tag: string) => {
  activeTag.value = activeTag.value === tag ? ALL_TAGS : tag;
};
const visibleItems = computed(() =>
  activeTag.value === ALL_TAGS
    ? props.items
    : props.items?.filter((item) => item.tags?.includes(activeTag.value)),
);

const view = computed(() =>
  !props.gridView ? BlogSectionSimpleSlider : BlogSectionSimpleGrid,
);

return { __sfc: true,ALL_TAGS, DEFAULT_TEXT_ALIGN, props, activeTag, tags, selectTag, visibleItems, view, AbTitle, AbSection, AbContainer, AbLink, AbIcon, AbSectionLayout, AbDescription, AbTag }
}

})